import type { ColorComponent, RGBColor } from "@pdfking/math"

// Any color CSS reads ("#f2c230", "rgb(…)", "oklch(…)", a name) as an
// RGBColor, the browser parsing it by painting one pixel; undefined when CSS
// does not read it as a color
export const CssColor = (value: string): RGBColor | undefined => {
  const ctx = new OffscreenCanvas(1, 1).getContext("2d", { willReadFrequently: true })!
  const unset = "#010203"
  ctx.fillStyle = unset
  ctx.fillStyle = value
  if (ctx.fillStyle === unset && value !== unset) return undefined
  ctx.fillRect(0, 0, 1, 1)
  const [red, green, blue, alpha] = [...ctx.getImageData(0, 0, 1, 1).data].map(
    channel => (channel / 255) as ColorComponent
  )
  return { alpha: alpha!, blue: blue!, green: green!, red: red! }
}
